/**
 * AutoComplete Field
 */

// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// ng2-primene Components
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AutoCompleteFieldComponent } from "./autocomplete-field.component";

import { ApiModule } from "../../../api.module";
import { AutoCompleteFb } from "./autoComplete-fb.component";
import { SearchService } from "./search.service";
import { AutoCompleteStaticFieldComponent } from "./autocomplete-static-field.component";
import { FocusMeModule } from "../../../../directive/focusMe/focusMe.module";
import { UIModule } from "../../../../ui/ui.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";

/**
 * @deprecated
 */
@NgModule({
    imports: [
        ApiModule,
        AutoCompleteModule,
        CommonModule,
        FocusMeModule,
        FormsModule,
        ReactiveFormsModule,
        UIModule,
        FontAwesomeModule,
        MultiselectModule,
    ],
    declarations: [
        AutoCompleteFb,
        AutoCompleteFieldComponent,
        AutoCompleteStaticFieldComponent,

    ],
    exports: [
        AutoCompleteFb,
        AutoCompleteFieldComponent,
        AutoCompleteStaticFieldComponent,
    ],
    providers: [
        SearchService,
    ]
})
export class AutoCompleteFieldModule {
}
